<!-- Translated: yes -->
<template>
  <div class="component">
    <div v-for="(maxages, minage) in data" v-if="SITE_CONFIG.modules_open.school.open">
      <div class="list" v-for="(schools, maxage) in maxages">
        <div class="list-header">
          <span v-if="isPrivate(schools) && (isSnowboard(schools) || $route.query.type === 'snowboard')">{{ (SITE_CONFIG.site === 'vallasen' || SITE_CONFIG.site === 'ulricehamn') ? $t('skischool.types-singular.private-snowboard') : $t('skischool.types.private-snowboard') }}</span>
          <span v-else-if="isPrivate(schools) || $route.query.type === 'private'">{{ (SITE_CONFIG.site === 'vallasen' || SITE_CONFIG.site === 'ulricehamn') ? $t('skischool.types-singular.private') : $t('skischool.types.private') }}</span>
          <span v-else-if="maxage < 70">{{ minage !== maxage ? minage + '-' + maxage : minage }} {{ $t('general.years') }}</span>
          <span v-else-if="maxage >= 70 && minage <= 0">
            <span v-if="$route.query.type === 'group'">{{ $t('skischool.types.group') }}</span>
            <span v-if="$route.query.type === 'snowboard'">{{ $t('skischool.types.snowboard') }}</span>
          </span>
          <span v-else-if="maxage >= 70 && minage > 0">{{ minage }}+ {{ $t('general.years') }}</span>
        </div>
        <transition-group name="animate-list" class="animate-list separator" tag="ul">
          <div v-for="level in schools" :key="(level.info.level + '-' + minage + '-' + maxage)" class="animate-list-item area-wrapper">
            <SkiSchoolListPool :level="level" />
          </div>
        </transition-group>
      </div>
    </div>
    <div class="no-results" v-if="!SITE_CONFIG.modules_open.school.open">
      <p>{{ SITE_CONFIG.modules_open.school.closed_message }}</p>
    </div>
    <div v-if="SITE_CONFIG.modules_open.school.open && (SITE_CONFIG.site === 'branas' || SITE_CONFIG.site === 'kungsberget')">
      <div class="no-results" v-if="!count">
        <b>Inga sökresultat</b>
        <p>Hittar du inte det du söker, skicka in en skidskoleförfrågan via <a href="/gastservice/kontakta-oss/">vårt formulär</a>.</p>
        <p v-if="SITE_CONFIG.site === 'kungsberget'">För alla vuxna erbjuder vi endast privatlektioner.</p>
      </div>
    </div>
  </div>
</template>

<script>
import SkiSchoolListPool from '@/components/parts/SkiSchool/SkiSchoolListPool';

export default {
  props: {
    data: {
      default: [],
    },
    count: {
      default: 1,
    },
  },
  components: {
    SkiSchoolListPool,
  },
  data() {
    return {
    };
  },
  methods: {
    isPrivate(schools) {
      if (!schools) return false;
      const first = Object.keys(schools).map(k => schools[k])[0];
      return !!(first && first.info && first.info.is_private);
    },
    isSnowboard(schools) {
      if (!schools) return false;
      const first = Object.keys(schools).map(k => schools[k])[0];
      return !!(first && first.info && first.info.is_snowboard);
    },
    openBooking() {

    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component
  transition-slide('animate-filter')
  transition all 0.3s
  padding-left: 15px;
  padding-right: 15px;

ul.animate-list
  transition-list('animate-list')
  padding-left: 0
.separator
  margin-bottom: 35px

.component
  max-width container-width
  margin-right auto
  margin-left auto

.list
  .list-header
    united-heavy()
    font-size size-font-3
    line-height size-font-3
    uppercase()
    border-radius: 2px
    background-color: #004d74
    color white
    padding space-1 space-1 space-half
    +max-tablet()
      border-radius: 0px


  .list-body
    // display flex
    // flex-wrap wrap
    // justify-content space-between
    // align-items: stretch;
    // display flex
    margin 0 -space-2 space-3
    +max-mobile()
      flex-wrap: wrap
      margin-left 0
      margin-right 0

    &:after
      content ""
      flex auto

    .list-item
      width 100%
      padding space-2
      align-items: stretch;
      display flex
      +max-mobile()
        width 100%

.no-results
  border: solid 1px #bfd9e1;
  padding 20px
  background-color: #ecf5f8;
  float none
  margin 0 auto
  margin-top 30px
  max-width 600px
  opacity 0
  transform all 0.2s
  opacity 1
  b
    uppercase()

</style>



// WEBPACK FOOTER //
// SkiSchoolList.vue?6d60f578